import React from 'react';

// Conversation Item Component
export const ConversationItem = ({ conversation, onClick }) => {
  const getOtherParticipant = () => {
    return conversation.participants_info?.[0] || null;
  };

  const getAvatarUrl = () => {
    const participant = getOtherParticipant();
    return participant?.avatar_url || 'https://ui-avatars.com/api/?name=' + participant.first_name + '+' + participant.last_name;
  };

  const getParticipantName = () => {
    const participant = getOtherParticipant();
    return participant ? `${participant.first_name} ${participant.last_name}` : 'Utilisateur';
  };

  const getLastMessage = () => {
    if (conversation.last_message) {
      // Si c'est un message image, afficher "Image envoyée"
      if (conversation.last_message.message_type === 'image') {
        return '📸 Image envoyée';
      }
      // Sinon afficher le contenu du message texte
      return conversation.last_message.content;
    }
    return 'Aucun message';
  };

  const getTimestamp = () => {
    if (conversation.last_message) {
      const date = new Date(conversation.last_message.created_at);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return 'Maintenant';
      if (diffMins < 60) return `${diffMins}m`;
      if (diffHours < 24) return `${diffHours}h`;
      if (diffDays < 7) return `${diffDays}j`;
      return date.toLocaleDateString('fr-FR');
    }
    return '';
  };

  const getListingImage = () => {
    if (conversation.listing && conversation.listing.images && conversation.listing.images.length > 0) {
      const firstImage = conversation.listing.images[0];
      if (typeof firstImage === 'string') {
        return firstImage;
      } else if (firstImage && typeof firstImage === 'object') {
        return firstImage.secure_url || firstImage.url || firstImage.original;
      }
    }
    // Image SVG statique pour éviter les erreurs de réseau
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNSAxNUgyNVYyNUgxNVYxNVoiIGZpbGw9IiM5Q0EzQUYiLz4KPHN2Zz4K';
  };

  return (
    <div 
      onClick={() => onClick(conversation)}
      className="flex items-center gap-3 p-4 border-b border-gray-100 active:bg-gray-50 cursor-pointer hover:bg-gray-50"
    >
      <div className="relative">
        <img 
          src={getAvatarUrl()} 
          alt={getParticipantName()}
          className="w-12 h-12 rounded-full object-cover"
          onError={(e) => {
            // Avatar SVG statique pour éviter les erreurs de réseau
            e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSIjRjNGNEY2IiByeD0iMjQiLz4KPHN2Zz4K';
          }}
        />
        {conversation.unread_count > 0 && (
          <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {conversation.unread_count > 9 ? '9+' : conversation.unread_count}
          </div>
        )}
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-semibold text-gray-900 truncate">{getParticipantName()}</h3>
          <span className="text-xs text-gray-500">{getTimestamp()}</span>
        </div>
        <p className="text-sm text-gray-600 truncate">{getLastMessage()}</p>
        {conversation.listing && (
          <p className="text-xs text-gray-400 mt-1 truncate">
            À propos de: {conversation.listing.title}
          </p>
        )}
      </div>
      
      {conversation.listing && (
        <img 
          src={getListingImage()} 
          alt="Listing"
          className="w-10 h-10 rounded object-cover"
          onError={(e) => {
            // Image SVG statique pour éviter les boucles d'erreur
            e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNSAxNUgyNVYyNUgxNVYxNVoiIGZpbGw9IiM5Q0EzQUYiLz4KPHN2Zz4K';
          }}
        />
      )}
    </div>
  );
};

